export default "__VITE_ASSET__BKU4aVFu__"